export default "__VITE_ASSET__PAdvV1IO__"